export enum TabObjectName {
  METRICS = 'Metrics',
  CMCD = 'CMCD',
  PLAYERCONFIG = 'Player Config',
  SEGMENTINSPECTOR = 'Segment Inspector',
  STALLDETECTOR = 'Stall Detector',
  PLAYERLOGS = 'Player Logs',
  HOTKEYS = 'HotKeys',
  URLVARS = 'URLVars',
  FEATURES = 'Features',
  TERMSOFUSE = 'Terms Of Use',
  SCTEDISPLAY = 'SCTE',
  SUBTITLES = 'Subtitles Viewer',
}
